import React, { useEffect, useState } from 'react';
import { PieChart } from 'react-minimal-pie-chart';
import { useTranslation } from 'react-i18next';
import styles from './PieView.module.scss';
import { getPercentStr, getPlus } from '../../../utils/count';
import Item from './Item';
import { CoinType } from '../../../enum';
import { formatNumber } from '../../../utils/format';
import { WalletAssetItem } from '../../../types/api';

type DataItem = {
  title: string;
  value: number;
  color: string;
  percent: string;
}

type Props = {
  addressList: WalletAssetItem[];
  total: number;
}

const PieView: React.FC<Props> = ({ addressList, total }) => {
  const { t } = useTranslation();
  const [data, setData] = useState<DataItem[]>([]);
  const [isSingle, setIsSingle] = useState<boolean>(false);
  useEffect(() => {
    const result: DataItem[] = [
      {
        title: 'BTC',
        color: '#0CBF92',
        value: 0,
        percent: '0%',
      },
      {
        title: 'ETH',
        color: '#000',
        value: 0,
        percent: '0%',
      },
      {
        title: t('others'),
        color: 'rgba(6, 8, 69, .1)',
        value: 0,
        percent: '0%',
      },
    ];
    if (total > 0) {
      addressList.forEach((item) => {
        const val = Number(item.usd) || 0;
        if (item.token_name === CoinType.BTC) {
          result[0].value = getPlus(result[0].value, val);
        } else if (item.token_name === CoinType.ETH) {
          result[1].value = getPlus(result[1].value, val);
        } else {
          result[2].value = getPlus(result[2].value, val);
        }
      });
      result[0].percent = getPercentStr(result[0].value, total);
      result[1].percent = getPercentStr(result[1].value, total);
      result[2].percent = getPercentStr(result[2].value, total);
    }
    if (result.find((item) => item.percent === '100%')) {
      setIsSingle(true);
    }
    setData(result);
  }, [addressList, total, t]);
  return (
    <div>
      <div className={styles.pieWrapper}>
        <PieChart
          data={data}
          lineWidth={20}
          paddingAngle={isSingle ? 0 : 4}
        />
        <div className={styles.valueList}>
          {data.map((item) => (
            <Item
              key={item.title}
              coin={item.title}
              percent={item.percent}
              count={`$${formatNumber(item.value)}`}
              color={item.color}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PieView;
